import { useEffect, useMemo } from "react"
import { useRefreshTokensMutation } from "@/api/auth/refresh"
import { AppAuthProviderTokensProps } from "./useAppAuthProvider.tokens"
import _ from "lodash"

const useAppAuthProviderTokensRefresh = (tokens: AppAuthProviderTokensProps) => {
    const { mutateAsync } = useRefreshTokensMutation()

    const debounceRefreshTokens = useMemo(
        () =>
            tokens.tokens
                ? _.debounce(async () => {
                      try {
                          if (tokens.tokens) {
                              const newTokens = await mutateAsync({ refreshToken: tokens.tokens?.refreshToken })
                              tokens.setTokens(newTokens)
                          }
                      } catch {
                          tokens.reset()
                      }
                  }, tokens.tokens?.accessTokenExpiresIn - 5 * 1000)
                : undefined,
        [mutateAsync, tokens]
    )

    useEffect(() => {
        if (tokens && debounceRefreshTokens) {
            debounceRefreshTokens()
            return () => debounceRefreshTokens.cancel()
        }
    }, [debounceRefreshTokens, tokens])

    return {}
}
export default useAppAuthProviderTokensRefresh
